import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ObservationDefinition } from 'app/mdm/lib/observation-definition/observation-definition';
import { CodeSystemConcept } from 'app/mdm/terminology-lib/services/codesystem';
import { CodeName, markAsDirty } from '@heda/core-util';
import { forkJoin } from 'rxjs';
import { CodeSystemService } from 'app/mdm/terminology-lib/services/codesystem.service';
import { MeasurementUnitService } from 'app/mdm/terminology-lib/services/measurement-unit.service';
import { MeasurementUnit } from 'app/mdm/terminology-lib/services/measurement-unit';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'hw-observation-definition-data-settings',
  templateUrl: 'observation-definition-data-settings.component.html',
})
export class ObservationDefinitionDataSettingsComponent implements OnInit {
  @Input() public editMode: boolean = true;
  @Input() public definition: ObservationDefinition;
  @ViewChild('form') public form: NgForm;

  public dataTypes: { [key: string]: CodeSystemConcept } = {};
  public measurementUnits: MeasurementUnit[] = [];

  constructor(private codeSystemService: CodeSystemService, private measurementUnitService: MeasurementUnitService) {}

  public ngOnInit(): void {
    forkJoin([this.codeSystemService.getConcepts('data-type'), this.measurementUnitService.query()]).subscribe(
      ([dataTypes, units]) => {
        this.dataTypes = dataTypes;
        this.measurementUnits = units;
      }
    );
  }

  public updateMeasurementUnit(dataType: CodeName): void {
    if (!this.dataTypes[dataType?.code]?.attributes['measurable']) {
      this.definition.unitKind = null;
      this.definition.defaultUnit = null;
    }
  }

  public clearDataTypeSettings(): void {
    this.definition.calculatedValue = null;
  }

  public filterAvailableDataTypes(concept: CodeSystemConcept): boolean {
    return [
      'code-system',
      'select',
      'decimal',
      'number',
      'quantity',
      'string',
      'snomed-concept',
      'snomed-select',
      'date',
      'time',
    ].includes(concept.code);
  }

  public filterByMeasurementUnitKind(unit: MeasurementUnit, kind: CodeName): boolean {
    return unit?.kind?.code === kind?.code;
  }

  public validate(): boolean {
    markAsDirty(this.form);
    return this.form.valid;
  }

  public byUnitCode(o1: MeasurementUnit, o2: MeasurementUnit): boolean {
    return o1 && o2 && o1.code === o2.code;
  }
}
